export type PermissionAction = {
  action_name: string;
  module?: {
    module_name?: string;
  };
};

export function buildPermissionMap(actions: PermissionAction[]) {
  return actions.reduce<Record<string, string[]>>((acc, action) => {
    const moduleName = action.module?.module_name;
    if (!moduleName) return acc;

    if (!acc[moduleName]) {
      acc[moduleName] = [];
    }

    acc[moduleName].push(action.action_name);
    return acc;
  }, {});
}
